import { render, staticRenderFns } from "./comDetail.vue?vue&type=template&id=3274bd8f&scoped=true&"
import script from "./comDetail.vue?vue&type=script&lang=js&"
export * from "./comDetail.vue?vue&type=script&lang=js&"
import style0 from "./comDetail.vue?vue&type=style&index=0&id=3274bd8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274bd8f",
  null
  
)

export default component.exports